import { atomWithStorage, createJSONStorage } from 'jotai/utils';
import { Enrollment } from './types';
import { atomEffect } from 'jotai-effect';

const defaultValues: Enrollment = {
  paymentMethod: undefined,
  loaded: undefined,
  insureds: [
    {
      insuredType: 'PRIMARY',
      firstName: '',
      lastName: '',
      dateOfBirth: '',
      email: null,
      genderCd: null,
      relationshipToPrimaryInsuredCd: null,
    },
  ],
  address: {
    addressLine1: '',
    addressLine2: '',
    city: '',
    stateCode: '',
    zipCode: '',
    country: 'US',
  },
  billingAddress: undefined,
  agreements: [],
  replacementCoverage: null,
};

const storage = createJSONStorage<Enrollment>(() => sessionStorage);
export const enrollment = atomWithStorage<Enrollment>(
  'enrollmentInfo',
  defaultValues,
  storage
);

export const validateEnrollmentEffect = atomEffect((get, set) => {
  const enrollmentValue = get(enrollment);
  if (
    typeof enrollmentValue.paymentMethod === 'undefined' &&
    typeof enrollmentValue.loaded === 'undefined'
  ) {
    set(enrollment, {
      ...enrollmentValue,
      paymentMethod: '',
      loaded: false,
    });
  }
});
